import { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';

export default (limitation: number, startDate: Dayjs) => {
    const result = startDate.add(limitation, 'months');
    return result;
};
